import { render, staticRenderFns } from "./q-company.vue?vue&type=template&id=4a591955&scoped=true&"
import script from "./q-company.vue?vue&type=script&lang=js&"
export * from "./q-company.vue?vue&type=script&lang=js&"
import style0 from "./q-company.vue?vue&type=style&index=0&id=4a591955&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a591955",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a591955')) {
      api.createRecord('4a591955', component.options)
    } else {
      api.reload('4a591955', component.options)
    }
    module.hot.accept("./q-company.vue?vue&type=template&id=4a591955&scoped=true&", function () {
      api.rerender('4a591955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-company.vue"
export default component.exports